import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, Input } from '@angular/core';
import { UserModel } from 'src/app/core/models/members/user/user.model';


@Component({
  selector: 'app-user-modal',
  templateUrl: './user-modal.component.html',
  styleUrls: ['./user-modal.component.scss']
})
export class UserModalComponent {

  userEdited: boolean = false;

  constructor(
    private modalRef: NgbActiveModal,
    ) { }

  @Input() public model: UserModel = new UserModel();
  @Input() public tenantId?: string;

  close(){
      this.modalRef.close();
  }

}
